import { render } from "./InvitationView.vue?vue&type=template&id=fe15a506&scoped=true"
import script from "./InvitationView.vue?vue&type=script&lang=js"
export * from "./InvitationView.vue?vue&type=script&lang=js"

import "./InvitationView.vue?vue&type=style&index=0&id=fe15a506&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fe15a506"]])

export default __exports__